export default __webpack_public_path__ + "static/media/3.ce12c296.jpeg";